import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { JsonObjectFactoryService } from '../../../shared/_services/json-object-factory.service';

/**
 * Replicates AngularJS GridFactory.getDataCustom for Admin Filters.
 * State api.get: base_url + "/loadGridJson?action_id=1102&grid_id=230" (from admin.js)
 */
@Injectable({ providedIn: 'root' })
export class AdminFiltersService {
  private readonly ACTION_ID = 1102;
  private readonly GRID_ID = 230;

  constructor(
    private http: HttpClient,
    private jsonObjectFactory: JsonObjectFactoryService
  ) {}

  loadGridData(
    baseUrl: string,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/loadGridJson?action_id=${this.ACTION_ID}&grid_id=${this.GRID_ID}`;
    const globalParams = globalService?.globalParams ?? globalService ?? {};
    const params = { ...globalParams, ...filterParams };
    const body = this.toFormUrlEncoded(params);
    return this.http.post<any>(url, body, {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' }),
      withCredentials: true,
    });
  }

  getFiltersUIType(baseUrl: string, clientKey: any, globalService: any, filterParams: any = {}): Observable<any> {
    const url = `${baseUrl}/getFiltersUIType`;
    const params = { clientKey: clientKey ?? '' };
    return this.jsonObjectFactory.saveJSON6(url, params, globalService || {}, filterParams || {});
  }

  getFiltersByKey(baseUrl: string, clientKey: any, filterGroupKey: any, globalService: any, filterParams: any = {}): Observable<any> {
    const url = `${baseUrl}/getFiltersByKey`;
    const params = {
      client_key: clientKey ?? '',
      filter_group_key: filterGroupKey ?? '',
    };
    return this.jsonObjectFactory.saveJSON6(url, params, globalService || {}, filterParams || {});
  }

  saveUpdateFiltersByClient(baseUrl: string, clientKey: any, filtersList: any[], globalService: any, filterParams: any = {}): Observable<any> {
    const url = `${baseUrl}/saveUpdateFiltersByClient`;
    const params = {
      client_key: clientKey ?? '',
      filterJson: JSON.stringify(filtersList || []),
    };
    return this.jsonObjectFactory.saveJSON6(url, params, globalService || {}, filterParams || {});
  }

  saveFilterGroupByClient(baseUrl: string, clientKey: any, filterGroup: any, filterMapList: any[], globalService: any, filterParams: any = {}): Observable<any> {
    const url = `${baseUrl}/saveFilterGroupByClient`;
    const params = {
      client_key: clientKey ?? '',
      filter_group_key: filterGroup?.filter_group_key ?? null,
      filter_group_name: filterGroup?.filter_group_name ?? '',
      filter_group_desc: filterGroup?.filter_group_desc ?? filterGroup?.desc ?? '',
      filter_group_type: filterGroup?.filter_group_type ?? '',
      filterGroupJson: JSON.stringify(filterMapList || []),
    };
    return this.jsonObjectFactory.saveJSON6(url, params, globalService || {}, filterParams || {});
  }

  removeFilter(baseUrl: string, clientKey: any, filterKey: any, globalService: any, filterParams: any = {}): Observable<any> {
    const url = `${baseUrl}/removeFilter`;
    const params = {
      clientKey: clientKey ?? '',
      filterKey: filterKey ?? '',
    };
    return this.jsonObjectFactory.saveJSON6(url, params, globalService || {}, filterParams || {});
  }

  removeFilterMap(baseUrl: string, clientKey: any, filterMapKey: any, globalService: any, filterParams: any = {}): Observable<any> {
    const url = `${baseUrl}/removeFilterMap`;
    const params = {
      clientKey: clientKey ?? '',
      filterMapKey: filterMapKey ?? '',
    };
    return this.jsonObjectFactory.saveJSON6(url, params, globalService || {}, filterParams || {});
  }

  private toFormUrlEncoded(params: any): string {
    const body = new URLSearchParams();
    Object.keys(params || {}).forEach((key) => {
      const value = params[key];
      if (value !== undefined && value !== null) {
        body.set(key, String(value));
      }
    });
    return body.toString();
  }
}
